<template>

    <div>
        <el-form :inline="true" :model="query" class="query-form" size="mini">
            <el-form-item class="query-form-item">
                <el-input v-model="query.username" placeholder="User Name"></el-input>
            </el-form-item>
            <el-form-item class="query-form-item">
                <el-select v-model="query.status" placeholder="Status">
                    <el-option label="All" value=""></el-option>
                    <el-option label="Disable" value="0"></el-option>
                    <el-option label="Normal" value="1"></el-option>
                </el-select>
            </el-form-item>
            <el-form-item class="query-form-item">
                <el-select v-model="query.roleId" placeholder="Roles">
                    <el-option label="All Roles" value=""></el-option>
                    <el-option v-for="item in roles" :key="item.id" :label="item.roleName" :value="item.id"></el-option>
                </el-select>
            </el-form-item>

            <el-form-item>
                <el-button-group>
                    <el-button type="primary" icon="el-icon-refresh" @click="onReset"></el-button>
                    <el-button type="primary" icon="search" @click="onSubmit">Query</el-button>
                    <el-button type="primary" v-if="authRulesFun('admin/auth/user/save')" @click.native="handleForm(null,null)">Add</el-button>
                </el-button-group>
            </el-form-item>
        </el-form>
        <el-scrollbar class="table-scrollbar" wrap-style="overflow-x: hidden;">
            <el-table
                v-loading="loading"
                :data="list"
                style="width: 100%;">
                <!-- <el-table-column
                    label="User ID"
                    prop="id"
                    fixed>
                </el-table-column> -->
                <el-table-column label="No."  type="index" width="50">
                </el-table-column>
                <el-table-column
                    label="User Name"
                    prop="username"
                    >
                </el-table-column>
                <el-table-column
                    label="Status">
                    <template slot-scope="scope">
                        <el-tag :type="scope.row.status | statusFilterType">{{scope.row.status | statusFilterName}}</el-tag>
                    </template>
                </el-table-column>
                <el-table-column
                    label="Roles">
                    <template slot-scope="scope">
                        {{rolesListFun(scope.row.roles)}}
                    </template>
                </el-table-column>
                <el-table-column
                    label="Last Login Time"
                    with="300"
                    :show-overflow-tooltip="true">
                    <template slot-scope="scope">
                        <i v-if="scope.row.lastLoginTime" class="el-icon-time"></i>
                        <span>{{ scope.row.lastLoginTime | formatDateStr('yyyy-MM-dd hh:mm:ss') }}</span>
                    </template>
                </el-table-column>
                <el-table-column
                    label="Last Login IP">
                    <template slot-scope="scope">
                        <span>{{ scope.row.lastLoginIp }}</span>
                    </template>
                </el-table-column>
                <el-table-column
                    label="Operation"
                    fixed="right" v-if="authRulesFun('admin/auth/user/edit')||authRulesFun('admin/auth/user/resetPassword')||authRulesFun('admin/auth/user/delete')">
                    <template slot-scope="scope">
                        <el-button type="text" size="small" v-if="authRulesFun('admin/auth/user/edit')" @click.native="handleForm(scope.$index, scope.row)">Edit</el-button>
                        <el-button type="text" size="small" v-if="authRulesFun('admin/auth/user/resetPassword')" @click.native="handleFormPass(scope.$index, scope.row)">Reset Password </el-button>
                        <el-button type="text" size="small" v-if="authRulesFun('admin/auth/user/delete')" @click.native="handleDel(scope.$index, scope.row)">Delete</el-button>
                    </template>
                </el-table-column>
            </el-table>
        </el-scrollbar>

        <el-pagination
            :page-size="query.limit"
            @current-change="handleCurrentChange"
            layout="total,prev, pager, next"
            :total="total">
        </el-pagination>

        <!--form-->
        <el-dialog :title="formMap[formName]" :visible.sync="formVisible" :before-close="hideForm" width="85%" top="5vh">
            <el-form :model="formData" :rules="formRules" ref="dataForm">
                <el-form-item label="User" prop="username">
                    <el-input v-model.trim="formData.username" maxlength="60" auto-complete="off"></el-input>
                </el-form-item>
                <el-form-item label="Password" v-if="formMap[formName]!='Edit'" prop="password">
                    <el-input type="password" maxlength="20" v-model.trim="formData.password" auto-complete="off"></el-input>
                </el-form-item>
                <el-form-item label="Confirm Password" v-if="formMap[formName]!='Edit'" prop="checkPassword">
                    <el-input type="password" maxlength="20" v-model.trim="formData.checkPassword" auto-complete="off"></el-input>
                </el-form-item>
                <el-form-item label="Status" prop="status">
                    <el-radio-group v-model="formData.status">
                        <el-radio :label="0">Disable</el-radio>
                        <el-radio :label="1">Normal</el-radio>
                        <!-- <el-radio :label="2">未验证</el-radio> -->
                    </el-radio-group>
                </el-form-item>
                <el-form-item label="Roles" prop="roles">
                    <el-checkbox-group v-model.trim="formData.roles">
                        <el-checkbox v-for="item in roles" :key="item.id" :label="item.id">{{item.roleName}}</el-checkbox>
                    </el-checkbox-group>
                </el-form-item>
                <el-form-item label="Business Code" prop="brandId">
                    <el-select v-model="formData.brandId" clearable placeholder="Status">
                        <el-option v-for="(item,index) in tenantlist" :key="index" :label="item.businessCode" :value="item.id">
                            <span style="float: left">{{ item.brandName }}</span>
                            <span style="float: right; color: #8492a6; font-size: 13px">{{ item.businessCode }}</span>
                        </el-option>
                    </el-select>
                </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button @click.native="hideForm">Cancel</el-button>
                <el-button type="primary" @click.native="formSubmit()" :loading="formLoading">Save</el-button>
            </div>
        </el-dialog>

        <!-- reset password  -->
        <el-dialog title="Reset Password" :visible.sync="formVisiblePass" :before-close="hideFormPass" width="50%" top="5vh">
            <el-form :model="formDataPass" :rules="formRulesPass" ref="dataFormPass">
                <el-form-item label="Password"  prop="password">
                    <el-input type="password" maxlength="20" v-model.trim="formDataPass.password" auto-complete="off"></el-input>
                </el-form-item>
                <el-form-item label="Confirm Password"  prop="checkPassword">
                    <el-input type="password" maxlength="20" v-model.trim="formDataPass.checkPassword" auto-complete="off"></el-input>
                </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button @click.native="hideFormPass">Cancel</el-button>
                <el-button type="primary" @click.native="formSubmitPass()" :loading="formLoading">Save</el-button>
            </div>
        </el-dialog>
    </div>

</template>

<script>
import {
    authAdminList,
    authAdminRoleList,
    authAdminSave,
    authAdminDelete,
    authAdminSaveResetPassword
} from "../../../api/auth/authAdmin";
import {
    brandList
} from "../../../api/auth/brand";
const formJson = {
    id: "",
    password: "",
    username: "",
    checkPassword: "",
    status: 1,
    brandId:'',
    roles: []
};
export default {
    data() {
        let validatePass = (rule, value, callback) => {
            if (value === "") {
                callback(new Error("Please input a password"));
            } else {
                callback();
            }
        };
        let validatePass2 = (rule, value, callback) => {
            if (value === "") {
                callback(new Error("Please enter the password again"));
            } else if (value !== this.formData.password) {
                callback(new Error("The two passwords are inconsistent!"));
            } else {
                callback();
            }
        };
        let validatePass3 = (rule, value, callback) => {
            if (value === "") {
                callback(new Error("Please enter the password again"));
            } else if (value !== this.formDataPass.password) {
                callback(new Error("The two passwords are inconsistent!"));
            } else {
                callback();
            }
        };
        return {
            authRules:this.$store.state.admin.authRules,
            formVisiblePass:false,
            roles: [],
            query: {
                username: "",
                status: "",
                page: 1,
                limit: 20,
                roleId: ""
            },
            list: [],
            tenantlist: [],
            total: 0,
            loading: true,
            index: null,
            formName: null,
            formMap: {
                Add: "Add",
                Edit: "Edit"
            },
            formLoading: false,
            formVisible: false,
            formData: formJson,
            formRules: {},
            formDataPass: {
                id: "",
                password: "",
                checkPassword: ""
            },
            addRules: {
                username: [
                    { required: true, message: "Please enter your name", trigger: "blur" }
                ],
                password: [
                    { required: true, message: "Please input a password", trigger: "blur" },
                    { validator: validatePass, trigger: "blur" }
                ],
                checkPassword: [
                    {
                        required: true,
                        message: "Please enter the password again",
                        trigger: "blur"
                    },
                    { validator: validatePass2, trigger: "blur" }
                ],
                status: [
                    { required: true, message: "Please select a status", trigger: "change" }
                ],
                roles: [
                    { required: true, message: "Please select a roles", trigger: "change" }
                ],
                brandId: [
                    { required: true, message: "Please select a brand", trigger: "change" }
                ]
            },
            editRules: {
                username: [
                    { required: true, message: "Please enter your name", trigger: "blur" }
                ],
                status: [
                    { required: true, message: "Please select a status", trigger: "change" }
                ],
                roles: [
                    { required: true, message: "Please select a roles", trigger: "change" }
                ],
                brandId: [
                    { required: true, message: "Please select a brand", trigger: "change" }
                ]
            },
            formRulesPass:{
                password: [
                    { required: true, message: "Please input a password", trigger: "blur" },
                    { validator: validatePass, trigger: "blur" }
                ],
                checkPassword: [
                    {  required: true,  message: "Please enter the password again",  trigger: "blur" },
                    { validator: validatePass3, trigger: "blur" }
                ],
            },
            deleteLoading: false
        };
    },
    methods: {
        rolesListFun(data){
            var text=''
            for(var a=0;a<this.roles.length;a++){
                for(var b=0;b<data.length;b++){
                    if(this.roles[a].id==data[b]){
                        text += ' / '+this.roles[a].roleName
                    }
                }
            }
            return text.substr(2)
        },
        authRulesFun(url){
            if(this.authRules.length==1 && this.authRules[0]=='admin'){
                return true
            }
            var status = false
            for(var a=0;a<this.authRules.length;a++){
                if(this.authRules[a]==url){
                    status = true
                    break;
                }else {
                    status = false
                }
            }
            return status
        },
        onReset() {
            this.$router.push({
                path: ""
            });
            this.query = {
                username: "",
                status: "",
                page: 1,
                limit: 20,
                roleId: ""
            };
            this.getList();
        },
        onSubmit() {
            this.$router.push({
                path: "",
                query: this.query
            });
            this.getList();
        },
        handleCurrentChange(val) {
            this.query.page = val;
            this.getList();
        },
        getList() {
            this.loading = true;
            authAdminList(this.query)
                .then(response => {
                    this.loading = false;
                    if (response.code) {
                        this.$message.error(response.message);
                    }
                    this.list = response.data.list || [];
                    this.total = response.data.total || 0;
                })
                .catch(() => {
                    this.loading = false;
                    this.list = [];
                    this.total = 0;
                    this.roles = [];
                });
        },
        getTenantList() {
            this.loading = true;
            brandList({page: 1,
                limit: 50,})
                .then(response => {
                    this.loading = false;
                    if (response.code) {
                        this.$message.error(response.message);
                    }
                    this.tenantlist = response.data.list || [];
                })
                .catch(() => {
                    this.loading = false;
                });
        },
        getRoleList() {
            if(!this.authRulesFun('admin/auth/user/roleList')){
                return
            }
            authAdminRoleList(this.query)
                .then(response => {
                    if (response.code) {
                        this.$message.error(response.message);
                        return false;
                    }
                    this.roles = response.data.list || [];
                })
                .catch(() => {});
        },
        // Hide form
        hideForm() {
            // update value
            this.formVisible = !this.formVisible;
            return true;
        },
         // Hide form
        hideFormPass() {
            // update value
            this.formVisiblePass = !this.formVisiblePass;
            return true;
        },
        // updata form
        resetForm() {
            if (this.$refs["dataForm"]) {
                // clean form
                this.$refs["dataForm"].clearValidate();
                // updata form
                this.$refs["dataForm"].resetFields();
            }
        },
        // show form
        handleForm(index, row) {
            this.formVisible = true;
            this.formData = JSON.parse(JSON.stringify(formJson));
            if (row !== null) {
                this.formData = Object.assign({}, row);
            }
            this.formData.password = "";
            this.formData.checkPassword = "";
            this.formName = "Add";
            this.formRules = this.addRules;
            if (index !== null) {
                this.index = index;
                this.formName = "Edit";
                this.formRules = this.editRules;
            }
        },
        // show form
        handleFormPass(index, row) {
            this.formDataPass = {
                id: row.id ,
                password: "",
                checkPassword: ""
            }
            this.formVisiblePass = true;

        },
        formSubmitPass(){
            this.$refs["dataFormPass"].validate(valid => {
                if (valid) {
                    this.formLoading = true;
                    let data = Object.assign({}, this.formDataPass);
                    authAdminSaveResetPassword(data, 'Edit').then(response => {
                        this.formLoading = false;
                        if (response.code) {
                            this.$message.error(response.message);
                            return false;
                        }
                        this.$message.success("Successfully");
                        this.formVisiblePass = false;
                    });
                }
            });
        },
        formSubmit() {
            this.$refs["dataForm"].validate(valid => {
                if (valid) {
                    this.formLoading = true;
                    let data = Object.assign({}, this.formData);
                    authAdminSave(data, this.formName).then(response => {
                        this.formLoading = false;
                        if (response.code) {
                            this.$message.error(response.message);
                            return false;
                        }
                        this.$message.success("Successfully");
                        this.formVisible = false;
                        if (this.formName === "Add") {
                            // Add data to header
                            if (response.data && response.data.id) {
                                data.id = response.data.id;
                                this.list.unshift(data);
                            }
                        } else {
                            this.list.splice(this.index, 1, data);
                        }
                        // updata form
                        this.onSubmit();
                    });
                }
            });
        },
        // delete
        handleDel(index, row) {
            if (row.id) {
                this.$confirm("Are you sure to delete this record?", "Tips", {
                    type: "warning"
                })
                    .then(() => {
                        let para = { id: row.id };
                        this.deleteLoading = true;
                        authAdminDelete(para)
                            .then(response => {
                                this.deleteLoading = false;
                                if (response.code) {
                                    this.$message.error(response.message);
                                    return false;
                                }
                                this.$message.success("Successfully");
                                // updata data
                                this.list.splice(index, 1);
                                this.total--;
                            })
                            .catch(() => {
                                this.deleteLoading = false;
                            });
                    })
                    .catch(() => {
//                        this.$message.error("Cancel");
                    });
            }
        }
    },
    filters: {
        statusFilterType(status) {
            const statusMap = {
                0: "gray",
                1: "success",
                2: "danger"
            };
            return statusMap[status];
        },
        statusFilterName(status) {
            const statusMap = {
                0: "Disable",
                1: "Normal",
                2: "Not verified"
            };
            return statusMap[status];
        }
    },
    mounted() {},
    created() {
        // Copy parameters into query object
        let query = this.$route.query;
        this.query = Object.assign(this.query, query);
        this.query.limit = parseInt(this.query.limit);
        this.getList();
        // Load role list
        this.getRoleList();
        this.getTenantList();
    }
};
</script>

<style type="text/scss" lang="scss">
</style>
